'use client'

import { useProductPromotions } from '@/hooks/react-query/products/use-product'
import { useProductDetail } from '@/hooks/zustands/use-product-detail'
import { useTranslations } from 'next-intl'
import { useEffect } from 'react'
import { ProductPromotionGiftItem } from './product-promotion-gift-item'

export const ProductPromotionGift = ({ productId }: { productId: string }) => {
  const { data: promotionGifts } = useProductPromotions(productId)
  const { giftData, setGiftData } = useProductDetail()
  // Chỉ hiển thị quà tặng đầu tiên
  const firstGift = promotionGifts?.[0]
  const t = useTranslations('title')

  useEffect(() => {
    if (firstGift?.variants?.length) {
      setGiftData({
        id: firstGift?.id || '',
        optionId: firstGift?.variants?.[0]?.id || '',
        price: firstGift?.compare_price || 0,
      })
    }
  }, [setGiftData, firstGift])

  if (!firstGift?.variants?.length) return null

  return (
    <div className='flex w-full flex-col gap-2 overflow-hidden rounded-2xl bg-neutral-50 px-4 py-2'>
      <p className='text-sm leading-5 text-[#020817]'>{t('gift_with_order')}</p>
      <ProductPromotionGiftItem
        gift={firstGift}
        isSelected={firstGift.id === giftData?.id}
      />
    </div>
  )
}
